import { TFunction } from '@lyearn/i18n';
import getHumanDuration from '@/utils/time/getHumanDurationRounded';
import { getRemainingDuration } from '@/utils/time/getRemainingDuration';

import { CONTENT_TYPE_CAN_USE_PROGRESS } from '../getContentProgress';
import { Content, ContentPerformanceStatusEnum, StatusTranslationKeys } from '../types';
import getStatus from '../useStatus/getStatus';

const DEFAULTS = {
  NOT_STARTED: 'ContentCards.Duration',
  IN_PROGRESS: 'ContentCards.left',
  COMPLETED: 'ContentCards.Duration',
};

const getDuration = (content: Content, remainingDuration: string) => {
  const status = getStatus(content);
  const duration = content.duration || 0;

  switch (status) {
    case ContentPerformanceStatusEnum.NotStarted:
    case ContentPerformanceStatusEnum.Completed:
      return { status, duration: getHumanDuration(duration) };
    case ContentPerformanceStatusEnum.InProgress:
    default:
      return {
        status,
        duration: remainingDuration,
      };
  }
};

export const getContentDuration = (
  t: TFunction,
  content: Content,
  translationKeys?: StatusTranslationKeys,
) => {
  const i18n = { ...DEFAULTS, ...translationKeys };

  const totalDuration = content.duration || 0;
  const estimatedTimeSpent = content.performance?.estimatedTimeSpent || 0;
  const progress = content.performance?.progress || 0;

  const remainingDuration =
    content.type && CONTENT_TYPE_CAN_USE_PROGRESS.includes(content.type)
      ? getRemainingDuration(totalDuration, progress) // to keep in sync with course left duration at other places
      : getHumanDuration(totalDuration - estimatedTimeSpent);

  const { duration, status } = getDuration(content, remainingDuration);
  const total = getHumanDuration(totalDuration, true);

  return {
    totalDuration: total,
    duration: t(i18n[status], { time: duration }),
    status,
    remainingDuration: t(i18n.IN_PROGRESS, { time: remainingDuration }),
  };
};
